import type { FormProps, Input } from '../../types'
import style from '../form.module.css'

export default function CustomCheckbox({
  field,
  formProps,
}: {
  field: Input
  formProps: FormProps
}) {
  return (
    <input
      type="checkbox"
      placeholder={field.uiOptions?.placeholder}
      className={style.customInput}
      value={field.value}
      {...formProps?.register(field.name, {
        value: field.value,
      })}
      data-testid={field.uiOptions?.testId}
      disabled={field.uiOptions?.disabled}
    />
  )
}
